import { render, staticRenderFns } from "./StarConfigDialog.vue?vue&type=template&id=6b459325&scoped=true"
import script from "./StarConfigDialog.vue?vue&type=script&lang=js"
export * from "./StarConfigDialog.vue?vue&type=script&lang=js"
import style0 from "./StarConfigDialog.vue?vue&type=style&index=0&id=6b459325&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b459325",
  null
  
)

export default component.exports